(function(){
  'use strict';

  // ── Nav scroll ──────────────────────────────
  var nav = document.getElementById('mainNav');
  if(nav){
    function onScroll(){ nav.classList.toggle('scrolled', window.scrollY > 40); }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  // ── Mobile menu ─────────────────────────────
  var burger = document.getElementById('navBurger');
  var mobile = document.getElementById('navMobile');
  if(burger && mobile){
    burger.addEventListener('click', function(){
      mobile.classList.toggle('open');
      var isOpen = mobile.classList.contains('open');
      burger.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', function(e){
      if(nav && !nav.contains(e.target)){
        mobile.classList.remove('open');
        burger.setAttribute('aria-expanded','false');
      }
    });
  }

  // ── Scroll reveal ────────────────────────────
  var reveals = document.querySelectorAll('.reveal');
  if(reveals.length && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    },{threshold:0.1});
    reveals.forEach(function(el){ io.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('visible'); });
  }

  // ── FAQ accordion ────────────────────────────
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function(i){
        i.classList.remove('open');
        i.querySelector('.faq-q').setAttribute('aria-expanded','false');
      });
      if(!isOpen){
        item.classList.add('open');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });

  // ── Smooth anchor links ───────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(id.length < 2) return;
      var target = document.querySelector(id);
      if(target){
        e.preventDefault();
        var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 72;
        window.scrollTo({top: target.offsetTop - offset, behavior:'smooth'});
        if(mobile){ mobile.classList.remove('open'); }
      }
    });
  });

  // ── Product gallery thumbnails ────────────────
  var mainImg = document.getElementById('MainImg');
  document.querySelectorAll('.thumb').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(mainImg){
        mainImg.style.opacity = '0';
        setTimeout(function(){
          mainImg.src = btn.dataset.src;
          mainImg.style.opacity = '1';
        }, 180);
      }
      document.querySelectorAll('.thumb').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // ── Qty buttons ──────────────────────────────
  document.querySelectorAll('.qty-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = btn.closest('.qty-wrap') ? btn.closest('.qty-wrap').querySelector('.qty-input') : null;
      if(!input) return;
      var v = parseInt(input.value) || 1;
      if(btn.dataset.dir === 'up') v++;
      else if(v > 1) v--;
      input.value = v;
    });
  });

  // ── Active nav on scroll ──────────────────────
  var sections = document.querySelectorAll('section[id]');
  var navLinks = document.querySelectorAll('.nav-links a');
  if(sections.length && navLinks.length){
    window.addEventListener('scroll', function(){
      var cur = '';
      sections.forEach(function(s){
        if(window.scrollY >= s.offsetTop - 120) cur = s.id;
      });
      navLinks.forEach(function(a){
        var href = a.getAttribute('href');
        if(href === '#'+cur){ a.classList.add('active'); }
        else { a.classList.remove('active'); }
      });
    }, {passive:true});
  }

})();


// Upsell — Tartufi in den Warenkorb
document.querySelectorAll('.upsell-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var id = btn.dataset.productId;
    btn.textContent = '…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function() {
      btn.textContent = '✓ Hinzugefügt!';
      btn.classList.remove('btn-rose');
      btn.classList.add('btn-filled');
    })
    .catch(function() {
      btn.textContent = 'Fehler — nochmals versuchen';
      btn.disabled = false;
    });
  });
});


document.querySelectorAll('.upsell-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    btn.textContent = '…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: 59497739321678, quantity: 1 })
    })
    .then(function() { location.reload(); })
    .catch(function() {
      btn.textContent = 'Fehler — nochmals versuchen';
      btn.disabled = false;
    });
  });
});